<template>
  <div>
    <div>
      <el-switch
        :value="offlineModeEnabled"
        @change="handleOfflineToggleChange">
      </el-switch>
      <label>{{ $t('accountSettingsOfflineFieldLabel') }}</label>
    </div>
    <el-alert
      v-if="downloadError"
      :title="$t('accountSettingsOfflineDownloadError')"
      type="error"
      show-icon>
    </el-alert>
    <p>
      <a href @click.prevent="reload">{{ $t('accountSettingsOfflineReload') }}</a>
    </p>
  </div>
</template>

<script>
  import offline from '@/offline';
  import {mapState, mapActions, mapGetters} from 'vuex';

  export default {
    name: 'OfflineSetting',
    computed: {
      ...mapState(offline.downloadStore.namespace, [
        'offlineModeEnabled',
        'downloadInitialized',
        'downloadLoading',
        'downloadReady',
        'downloadUpdating',
        'downloadError'
      ]),
    },
    methods: {
      ...mapActions(offline.downloadStore.namespace, [
        'setOfflineModeEnabled'
      ]),
      handleOfflineToggleChange(value, event){
        console.info('handleOfflineToggleChange', arguments);
        this.setOfflineModeEnabled({ enabled: value, keepState: true });
      },
      reload() { window.location.reload(); }
    }
  }
</script>

<style lang="scss" scoped>
</style>
